import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import BgImg from "../../../images/case-studies/soundly/tech.webp";
import { StaticImage } from "gatsby-plugin-image";

function Technology() {
  return (
    <section
      className="technology p-100 case_soundly"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <div className="outcome_img">
        <StaticImage
          src="../../../images/case-studies/soundly/tech_logo.webp"
          alt="Soundly_TekRevol"
          layout="constrained"
          placeholder="blurred"
          formats={["webp"]}
          width={380}
          height={450}
        />
      </div>
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={6} xxl={6} className="my-auto">
            <h2>
              Technologies <span>Used</span>
            </h2>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="offset-xl-3 offset-lg-3"
          >
            <div className="tech_list">
              <ul>
                <li>
                  <div className="tech_text">
                    <h5>
                      Design Protoyping <span>Adobe XD</span>
                    </h5>
                  </div>
                  <div className="tech_img">
                    <StaticImage
                      src="../../../images/case-studies/soundly/logo1.webp"
                      alt="Soundly_TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={133}
                      height={80}
                    />
                  </div>
                </li>
                <li>
                  <div className="tech_text">
                    <h5>
                      Backend - APIs & Admin Panel <span>PHP/MySQL</span>
                    </h5>
                  </div>
                  <div className="tech_img">
                    <StaticImage
                      src="../../../images/case-studies/soundly/logo2.webp"
                      alt="Soundly_TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={133}
                      height={80}
                    />
                  </div>
                </li>
                <li>
                  <div className="tech_text">
                    <h5>
                      Frontend Mobile App <span>Native Android</span>
                      <span>Native iOS</span>
                    </h5>
                  </div>
                  <div className="tech_img">
                    <StaticImage
                      src="../../../images/case-studies/soundly/logo3.webp"
                      alt="Soundly_TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={133}
                      height={80}
                    />
                  </div>
                </li>
                <li>
                  <div className="tech_text">
                    <h5>
                      Server & Hosting <span>AWS - S3</span>
                    </h5>
                  </div>
                  <div className="tech_img">
                    <StaticImage
                      src="../../../images/case-studies/soundly/logo4.webp"
                      alt="Soundly_TekRevol"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={133}
                      height={80}
                    />
                  </div>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="offset-xl-2 offset-lg-2"
          >
            <h2>
              <span style={{ display: "inline-block" }}>The</span> Outcome
            </h2>
            <div className="outcome_content">
              <p>
                The team expanded the functionality and features of the app that
                enabled Soundly to become one of the most applauded apps in the
                creator's market.
              </p>
              <p>
                Integrating core features and functionality to support the prime
                purpose of the app, Soundly was capable of enabling creators to
                upload their songs, create their profiles, and even start
                earning revenue.
              </p>
              <p>
                The app's success is projected to hit a million+ downloads in
                the coming few years, mainly due to its unmatched experience and
                boundless features.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Technology;
